import { Box, styled } from "@mui/material";
import { Check } from "lucide-react";
import { tokens } from "@styles/tokens";

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
}

/** Design-system checkbox with label — brand fill when checked. */
export const Checkbox = ({ checked, onChange, label }: CheckboxProps) => (
  <Root>
    <HiddenInput
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
    />
    <Mark $checked={checked}>{checked && <Check size={14} strokeWidth={3} />}</Mark>
    {label && <span>{label}</span>}
  </Root>
);

const Root = styled("label")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: tokens.space(2),
  cursor: "pointer",
  fontFamily: tokens.font.family,
  fontSize: tokens.font.size.small[0],
  color: theme.skuey.body,
  userSelect: "none",
}));

const HiddenInput = styled("input")({
  position: "absolute",
  opacity: 0,
  width: 0,
  height: 0,
});

const Mark = styled(Box, {
  shouldForwardProp: (p) => p !== "$checked",
})<{ $checked: boolean }>(({ theme, $checked }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 18,
  height: 18,
  borderRadius: 5,
  flexShrink: 0,
  color: theme.skuey.white,
  border: `1.5px solid ${$checked ? theme.skuey.brand[600] : theme.skuey.borderStrong}`,
  backgroundColor: $checked ? theme.skuey.brand[600] : theme.skuey.surface,
  transition: "background-color .15s ease, border-color .15s ease",
}));
